export const computeModelSelectorUrl = (modelInfo) => (shoppingLinks) => {
  const { defaultModelSelectorUrl } = modelInfo;
  return shoppingLinks.modelSelectorUrl || defaultModelSelectorUrl;
};
